(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initHeroRotator = (root) => {
    const slides = [...root.querySelectorAll('[data-dbi-hero-slide]')];
    const dots = [...root.querySelectorAll('[data-dbi-hero-dot]')];
    const note = root.querySelector('.dbi-home__hero-note');
    const noteKicker = note?.querySelector('.dbi-home__hero-note-kicker');
    const noteTagline = note?.querySelector('strong');
    const visual = root.querySelector('.dbi-home__hero-visual');

    if (slides.length < 2 || !noteKicker || !noteTagline) return;

    let activeIndex = 0;
    let timer;

    const schedule = (delay = 3600) => {
      window.clearTimeout(timer);
      if (reduceMotion.matches || document.hidden) return;
      timer = window.setTimeout(() => showSlide((activeIndex + 1) % slides.length), delay);
    };

    const updateNote = (slide) => {
      note.classList.remove('is-changing');
      void note.offsetWidth;
      noteKicker.textContent = slide.dataset.dbiSlideKicker || 'Luxury made easy';
      noteTagline.textContent = slide.dataset.dbiSlideTagline || 'Curated globally, delivered beautifully';
      note.classList.add('is-changing');
    };

    const showSlide = (nextIndex, reschedule = true) => {
      const normalizedIndex = (nextIndex + slides.length) % slides.length;
      if (normalizedIndex === activeIndex) {
        if (reschedule) schedule();
        return;
      }

      const current = slides[activeIndex];
      const next = slides[normalizedIndex];

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      current.setAttribute('aria-hidden', 'true');

      next.classList.remove('is-leaving');
      next.classList.add('is-active');
      next.setAttribute('aria-hidden', 'false');

      dots.forEach((dot) => {
        const isActive = Number(dot.dataset.dbiHeroDot) === normalizedIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', String(isActive));
      });

      activeIndex = normalizedIndex;
      root.dataset.dbiActiveSlide = String(activeIndex);
      updateNote(next);

      window.setTimeout(() => current.classList.remove('is-leaving'), 760);
      if (reschedule) schedule();
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => showSlide(Number(dot.dataset.dbiHeroDot)));
    });

    visual?.addEventListener('pointerenter', () => window.clearTimeout(timer));
    visual?.addEventListener('pointerleave', () => schedule());
    visual?.addEventListener('focusin', () => window.clearTimeout(timer));
    visual?.addEventListener('focusout', () => schedule());

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) window.clearTimeout(timer);
      else schedule();
    });

    root.dataset.dbiActiveSlide = '0';
    schedule(1000);
  };

  const initHomepageMotion = (scope = document) => {
    const roots = scope.querySelectorAll('.dbi-home:not([data-dbi-motion-bound])');

    roots.forEach((root) => {
      root.setAttribute('data-dbi-motion-bound', 'true');
      initHeroRotator(root);

      if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

      const main = root.closest('main') || document.querySelector('main');
      const targets = [
        ...root.querySelectorAll(
          '.dbi-home__section-heading, .dbi-home__department-card, .dbi-home__product-card, .dbi-home__promise-item'
        ),
        ...(main ? [...main.children].slice(1) : []),
      ];

      root.classList.add('dbi-motion-ready');

      targets.forEach((target, index) => {
        target.classList.add('dbi-motion-target');
        target.style.setProperty('--dbi-reveal-delay', `${(index % 4) * 75}ms`);
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );

      targets.forEach((target) => observer.observe(target));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHomepageMotion());
  } else {
    initHomepageMotion();
  }

  document.addEventListener('shopify:section:load', (event) => initHomepageMotion(event.target));
})();
